import subMenuBuild from '@/utils/subitems.links.build';

export default function (locale: string, $t: (a: any) => any) {
  return [
    {
      id: 'home_products',
      items: subMenuBuild(locale, [
        {
          title: $t('privacy_and_security'),
          items: [
            {
              title: $t('privacy'),
              routes: [
                {
                  title: $t('nnp_vpn'),
                  path: '/home/privacy/vpn',
                },
              ],
            },
          ],
        },
        {
          title: $t('FREE_TOOLS_DOWNLOADS'),
          items: [
            // {
            //   title: $t('WEB'),
            //   routes: [
            //     {
            //       title: $t('NNP_PASSWORD_GENERATOR'),
            //       path: '/tools/web/password-generator',
            //       enabled: true
            //     },
            //     {
            //       title: $t('PASSWORD_TESTER'),
            //       path: '/tools/web/password-score',
            //       enabled: true
            //     },
            //     {
            //       title: $t('HACK_CHECK'),
            //       path: '/tools/web/hack-check',
            //       enabled: true
            //     },
            //     {
            //       title: $t('SECRET_SHARER'),
            //       path: '/tools/web/secret-sharer',
            //       enabled: true
            //     },
            //   ],
            //   enabled: true
            // },
            {
              title: $t('MOBILE'),
              routes: [
                {
                  title: $t('NNP_QR_SCANNER'),
                  path: '/home/tools/mobile/qr_scanner',
                },
              ],
            },
          ],
        },
      ]),
    },
    {
      id: 'business_products',
      items: subMenuBuild(locale, []),
    },
    {
      id: 'company',
      items: subMenuBuild(locale, [
        {
          title: $t('company'),
          items: [
            {
              routes: [
                { title: $t('about'), path: '/about/company-info' },
                { title: $t('contact_us'), path: '#' },
              ],
            },
          ],
        },
      ]),
    },
  ];
}
